import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getNCFileById } from '@reducers/manufacture';
import { updateHeaderConfig } from '@reducers/details';
import { getToolById } from '@reducers/clampingTools';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import Times from '@v2/context/Times/page';
import { NCFileSearchItem } from '@interfaces/search';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { useToolDetails } from '@v2/pages/common/hooks/useToolsDetails';
import { scale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL_FOR_ITEM, SCREEN_PADDING_HORIZONTAL_FOR_PAGE } from '@v2/pages/common/constants/base.constants';

interface ToolsDetailsNCFileTimesProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const ToolsDetailsNCFileTimesComponent: FC<ToolsDetailsNCFileTimesProps> = ({ getToolById, updateHeaderConfig, getNCFileById, ncFileData }) => {
  const title = useTitle();

  useToolDetails({
    getToolById,
    updateHeaderConfig,
    getNCFileById,
    getFullNCFile: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <Times
        withoutPaddingHorizontal
        ncFileId={ncFileData?.data?.ncFileId}
        style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}
        horizontalOffset={SCREEN_PADDING_HORIZONTAL_FOR_PAGE * 2}
      />
    </DetailsPageWrapper>
  );
};

const ToolsDetailsNCFileTimes = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  getToolById,
  updateHeaderConfig,
  getNCFileById,
})(ToolsDetailsNCFileTimesComponent);

export { ToolsDetailsNCFileTimes };
